import debounce from "lodash.debounce";
import { useState } from "react";
import { useSearchBox } from "react-instantsearch";
import { colors } from "../../style";
import { SearchField } from "../ui";

const CallTranscriptionSearchBox = (props) => {
  const { query, refine } = useSearchBox(props);
  const [inputValue, setInputValue] = useState(query);

  const debouncedSetQuery = debounce((oldQuery, newQuery) => {
    refine(newQuery);
  }, 300);

  function setQuery(newQuery) {
    const oldQuery = inputValue;
    setInputValue(newQuery);
    debouncedSetQuery(oldQuery, newQuery);
  }

  return (
    <SearchField
      label="Search"
      autoCapitalize="off"
      autoComplete="off"
      autoCorrect="off"
      autoFocus
      maxLength={255}
      onChange={(event) => setQuery(event.currentTarget.value)}
      placeholder="Search extension, phone number, transcription content etc"
      spellCheck={false}
      value={inputValue}
      name="search"
      style={{ background: colors.pageBackground }}
    />
  );
};

export default CallTranscriptionSearchBox;
